<template>
  <div
    class="d-none d-lg-flex sidebar"
    :class="{'sidebar--mobile': mobile, 'sidebar--mobile--open': isOpen}"
  >
    <div v-if="mobile" />
    <div
      v-else
      class="d-flex justify-content-center sidebar__logo"
    >
      <a
        :href="tellimer"
        @click="$emit('click')"
        style="width: 48px; height: auto"
      >
        <img
          src="~@/assets/favicon.svg"
          alt="Tellimer"
          style="width: 48px; height: auto"
        >
      </a>
    </div>

    <router-link
      class="nav__item"
      :to="item.link"
      v-for="item in items"
      :key="item.text"
      @click.native="$emit('click')"
    >
      <icon
        :icon="item.icon"
        class="nav__item__icon"
      />
      {{ item.text }}
    </router-link>
  </div>
</template>


<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      required: true,
    },
    mobile: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      tellimer: process.env.VUE_APP_TELLIMER_URL,
    }
  },
}
</script>

<style lang="scss">
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  font-family: 'GT Cinetype', $font-family-sans-serif;
  width: $sidebar-width;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  color: $nav-link-color;
  background: $nav-bg;
  z-index: 999;
  transition: all 0.2s ease;
  &.sidebar--mobile {
    margin-top: 60px;
  }

  &__logo {
    padding: 4.5rem 0;
  }

  .nav__item {
    height: 32px;
    margin-bottom: 1.5rem;
    padding-left: 60px;
    display: flex;
    align-items: center;
    color: $nav-link-color;
    font-size: 16px;
    text-decoration: none;

    .i {
      margin-top: auto;
      margin-bottom: auto;
      margin-right: 1rem;
    }

    &:hover {
      color: white;
      .i {
        color: white;
      }
    }

    &.router-link-active {
      border-left: 2px solid $tellimer;
      color: white;
      padding-left: 58px;
    }
  }

  // MOBILE
  &--mobile {
    display: flex !important;
    left: unset;
    right: -$sidebar-width;

    &--open {
      right: 0;
    }
  }
}

.sidebar-overlay {
  position: fixed;
  top: 60px;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: #000;
  z-index: 809;
  transition: all 0.2s ease;
  pointer-events: none;
  opacity: 0;

  &--active {
    opacity: 0.75;
    pointer-events: unset;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .sidebar {
    &__logo {
      padding: 1rem 0;
      margin-top: 2rem;
      margin-bottom: 2rem;
      }
    &--mobile {
      left: auto;
    }
  }
}

</style>

